import { mapGetters } from "vuex";
import * as types from "@/store/types";
import authService from "@/services/modules/authService";

const SecurityTwoFactorAuth = () =>
  import(
    /* webpackChunkName: "SecurityTwoFactorAuth" */ "@/components/AccountPage/Security/SecurityTwoFactorAuth/index"
  );

const SecurityUserName = () =>
  import(
    /* webpackChunkName: "SecurityUserName" */ "@/components/AccountPage/Security/SecurityUserName/index"
  );

const SecurityPassword = () =>
  import(
    /* webpackChunkName: "SecurityPassword" */ "@/components/AccountPage/Security/SecurityPassword/index"
  );

const SecurityEnable2FAForLogin = () =>
  import(
    /* webpackChunkName: "enable2FAForLogin" */ "@/components/AccountPage/Security/enable2FAForLogin/index"
  );

const SecurityGoogleAuth = () =>
  import(
    /* webpackChunkName: "enable2FAForLogin" */ "@/components/AccountPage/Security/googleAuth/GoogleAuth"
  );
const otpSetting = () =>
  import(
    /* webpackChunkName: "otpSetting" */ "@/components/AccountPage/Security/otpSetting/index.vue"
  );

export default {
  name: "security",
  components: {
    SecurityTwoFactorAuth,
    SecurityUserName,
    SecurityPassword,
    SecurityEnable2FAForLogin,
    SecurityGoogleAuth,
    otpSetting
  },
  // props: [],
  data() {
    return {
      // userInfo: {}
      showDeleteAccountModal: false
    };
  },
  computed: {
    ...mapGetters({
      show2FA: types.account.getters.SHOW_2FA,
      showOtpSetting: types.account.getters.SHOW_OTP_SETTING,
      initData: types.init.getters.GET_INIT_DATA,
      showGoogleAuth: types.account.getters.SHOW_GOOGLE_AUTH,
      userInfo: types.userInfo.getters.GET_USER_INFO
    })
  },
  mounted() {
    // isEmpty(this.userInfo) &&
    //   UserService.getInfo().then(res => {
    //     this.setUserInfo(res.data.data);
    //     this.userInfo = res.data.data;
    //   });
  },
  methods: {
    deleteAccount() {
      authService.deleteAccounts().then(() => {
        localStorage.removeItem("accessToken");
        localStorage.setItem("isAuth", "false");
        this.$cookies.remove(
          "accessToken",
          null,
          process.env.VUE_APP_COOKIES_DOMAIN
        );
        location.reload();
      });
      // ...mapActions({
      //   setShow2FA: types.account.actions.SET_SHOW_2FA
      // })
    }
  }
};
